import {
  COMMON_HEADING_TRANSLATIONS,
  CommonTable,
} from '../../../TableCells/data';

export type PortfolioBuyerTable = CommonTable &
  Record<'withdrawInterest', string>;

export const TABLE_COLUMNS: Array<keyof PortfolioBuyerTable> = [
  'listing',
  'price',
  'ebitda',
  'state',
  'industry',
  'withdrawInterest',
];

export const HEADING_TRANSLATIONS = {
  ...COMMON_HEADING_TRANSLATIONS,
  withdrawInterest: 'withdraw',
};

export const SORTING_VALUES: Partial<
  Record<typeof TABLE_COLUMNS[number], string>
> = {};
